module.exports = __webpack_public_path__ + "img/heart.70241a77.svg";